module.exports = __webpack_public_path__ + "static/media/Firecompass logo Transparant.057b60e6.png";